import type { ScheduleStatus, DeviationStatus, ControllingReasonFilterValue } from '../../../../features/controlling/filters'
import type { MultiSelectOption } from '../../../../shared/ui/controls/MultiSelectDropdown'
import { getAbsenceCategoryLabel } from "../../../../entities/absence"

export const SCHEDULE_STATUS_OPTIONS: ReadonlyArray<MultiSelectOption<ScheduleStatus>> = [
  { value: 'WITHOUT_FOLLOW_UP', label: 'Ohne Folgetermin' },
  { value: 'WITH_FOLLOW_UPS', label: 'Mit Folgeterminen' },
/*   { value: 'RESCHEDULED_BY_OFFICE', label: 'Umdisponiert – durch Büro' },
  { value: 'RESCHEDULED_BY_TECHNICIAN', label: 'Umdisponiert – durch Handwerker' }, */
]

export const DEVIATION_STATUS_OPTIONS: ReadonlyArray<MultiSelectOption<DeviationStatus>> = [
  { value: 'ON_SCHEDULE', label: 'Planmäßig abgeschlossen' },
  { value: 'OVER_TARGET', label: 'Über Soll abgeschlossen' },
  { value: 'UNDER_TARGET', label: 'Unter Soll abgeschlossen' },
]

export const REASON_FILTER_OPTIONS: ReadonlyArray<MultiSelectOption<ControllingReasonFilterValue>> = [
  { value: 'MIETER_NICHT_VOR_ORT', label: 'Mieter war nicht vor Ort' },
  { value: 'TERMIN_NICHT_EINGEHALTEN', label: 'Termin nicht eingehalten' },
  { value: 'WEITERER_GRUND', label: 'Weiterer Grund' },
  { value: 'MIT_ANDEREM_GEWERK', label: 'Mit anderem Gewerk' },
  { value: 'MATERIAL_BESTELLUNG', label: 'Material Bestellung' },
  { value: 'SICK_LEAVE', label: getAbsenceCategoryLabel('SICK_LEAVE') },
  { value: 'VACATION', label: getAbsenceCategoryLabel('VACATION') },
  { value: 'TRAINING', label: getAbsenceCategoryLabel('TRAINING') },
  { value: 'PERSONAL_LEAVE', label: getAbsenceCategoryLabel('PERSONAL_LEAVE') },
]
